import type React from 'react';
import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { RadioGroup, type RadioGroupProps } from '@/components/controls';

export type FormRadioGroupProps = RadioGroupProps & {
  control?: Control;
  name: string;
  children: React.ReactNode[];
  label?: string;
  description?: string;
  error?: string;
};

export const FormRadioGroup = ({
  name,
  control,
  children,
  ...props
}: FormRadioGroupProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <RadioGroup {...props} onChange={onChange} value={value}>
            {children}
          </RadioGroup>
        );
      }}
    />
  );
};

FormRadioGroup.displayName = 'Form.RadioGroup';

export const required = (message = 'The field is required') => {
  return z
    .any()
    .refine((value) => value !== null && value !== undefined && value !== '', {
      message,
    });
};

FormRadioGroup.rules = { required };
